const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    width: '100%',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5),
    },
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
    },
  },
  roleMenuItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '&:hover': {
      backgroundColor: 'none',
    },
  },
  emailControl: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    minHeight: '78px',
    [theme.breakpoints.down('md')]: {
      minHeight: 'auto',
    },
  },
  inviteButton: {
    width: '15%',
    minWidth: '100px',
    marginTop: '6px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0.5),
    },
  },
})

export default styles
